import React from 'react'
import ValvesDetails from '../Components/ValvesDetails'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

const Valves = () => {
  return (
    <div>
      <Navbar />
      <ValvesDetails />
      <Footer />
    </div>
  )
}

export default Valves